import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Main from 'components/main';
import Auth from 'components/auth';
import apolloClient from 'graphql';
import * as theme from 'shared/styles/settings';
import GlobalStyle from 'shared/styles';
import { Provider } from 'react-redux';
import 'shared/styles';
import 'antd/dist/antd.less';
import './less/app.less';
import { store } from './shared/store';
import PrintProvider from 'react-easy-print';

export default function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <PrintProvider>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <GlobalStyle />
            <Router>
              <Switch>
                <Route exact path="/auth" component={Auth} />
                <Route path="/" component={Main} />
              </Switch>
            </Router>
          </Provider>
        </ThemeProvider>
      </PrintProvider>
    </ApolloProvider>
  );
}
